<!--
 * @Author:
 * @Description:
 * @Date: 2024-12-18 16:55:08
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-checkout-web/src/views/result/mobile/unknow.vue
-->
<template>
  <div class="result-box">
    <img class="img-result" src="@/assets/images/info.png" width="134" />
    <div class="margin-top-28 status">{{ $t('message.result.unknow') }}</div>
    <div class="margin-top-6 reason">{{ $t('message.result.unknowTip') }}</div>
    <div v-if="redirct && sourceChannel !== shopifySource" class="margin-top-10 jump"
      v-html="$t('message.result.jump', { time: time })"></div>
  </div>
</template>
<script>
import { getStatus, getBrandInfo } from '@/api/checkout';
import { deviceFingerprintManager } from '@/plugins/eventTrackManager/deviceFingerprintManager';
import { sendGaResultEvent } from '@/utils/tools/ga';
import { setRedirectFlag, hasRedirect } from '@/utils/tools/utils';

export default {
  data() {
    return {
      redirct: '',
      sourceChannel: '',
      time: 3,
      timer: null,
      shopifySource: 'shopify_plugin_v3',
      key: '',
      orderInfo: null,
    };
  },
  created() {
    this.key = this.$route.query.key ? this.$route.query.key : this.$route.params.id;
    getBrandInfo(this.key).then((res) => {
      if (res.respCode === '20000' && res.data) {
        this.$store.dispatch('app/setBrandInfo', res.data);
      }
    }).catch(() => ({}));
    getStatus(this.key).then((res) => {
      if (res.respCode === '20000') {
        this.orderInfo = res.data;
        this.sourceChannel = res.data.sourceChannel;
        const hRedirect = hasRedirect(this.key);
        if (!hRedirect) {
          this.redirct = res.data.redirectUrl;
          this.timerStart();
        }
      }
      this.sendGaEvent('visit_payment_result_page');
      this.sendRiskDeviceFingerPrint('visit_payment_result_page');
    }).catch(() => {
      this.sendGaEvent('visit_payment_result_page');
      this.sendRiskDeviceFingerPrint('visit_payment_result_page');
    });
    window.addEventListener('beforeunload', this.beforeUnloadEvent);
  },
  beforeDestroy() {
    this.sendGaEvent('exit_payment_result_page');
    this.sendRiskDeviceFingerPrint('exit_payment_result_page');
    window.removeEventListener('beforeunload', this.beforeUnloadEvent);
  },
  methods: {
    timerStart() {
      this.timer = setInterval(() => {
        this.time -= 1;
        if (this.time <= 0) {
          if (this.redirct && this.sourceChannel !== this.shopifySource) {
            setRedirectFlag(this.key);
            window.location.href = this.redirct;
          }
          clearInterval(this.timer);
        }
      }, 1000);
    },
    sendGaEvent(eventName) {
      sendGaResultEvent(this.$route.query.type, this.key, this.orderInfo, eventName);
    },
    beforeUnloadEvent() {
      this.sendRiskDeviceFingerPrint('exit_payment_result_page');
      this.sendGaEvent('exit_payment_result_page');
    },
    sendRiskDeviceFingerPrint(event) {
      const param = {
        m: this.$route.query.merchantTxnId || '',
        e: event,
      };
      deviceFingerprintManager.send(param);
    },
  },
};
</script>
